/**
 * @generated SignedSource<<5261052d6e6446c317c2c6536eef7f3f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type rowsContentRenderer_nativeIssueTable$data = {
  readonly __typename: "JiraIssueConnection";
  readonly " $fragmentType": "rowsContentRenderer_nativeIssueTable";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "rowsContentRenderer_nativeIssueTable";
};
export type rowsContentRenderer_nativeIssueTable$key = {
  readonly " $data"?: rowsContentRenderer_nativeIssueTable$data;
  readonly " $fragmentSpreads": FragmentRefs<"rowsContentRenderer_nativeIssueTable">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "rowsContentRenderer_nativeIssueTable",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "d9044b1ce14817e099635f23efb64eb3";

export default node;
